// extracted by mini-css-extract-plugin
export var errorsContainer = "_sd-1";
export var link = "_sd-0";